<script setup>
const features = [
  { icon: 'controller', text: '200+ games' },
  { icon: 'download', text: 'No install needed' },
  { icon: 'display', text: 'On any device' },
  { icon: 'people', text: 'Play with friends' },
  // { icon: 'cash', text: 'All for free' }
];
</script>

<template>
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center py-4">
        <div class="col-12">
          <div class="d-flex align-items-center mb-4">
            <!-- <div class="hero-logo bg-primary d-flex align-items-center justify-content-center rounded me-3"
              style="width: 48px; height: 48px;">
              <i class="bi bi-controller fs-2 text-white"></i>
            </div> -->
            <div class="hero-logo d-flex align-items-center justify-content-center rounded me-3" style="width: 60px; height: 60px;">
              <img src="../assets/Yalaagames.png" alt="YalaaGame" class="logo-image" crossorigin="anonymous"
                style="width: 70px; height: 70px;">
            </div>
            <h1 class="mb-0" style="color: #fff;">Welcome to <span class="" style="color: #F09F27;">YalaaGame</span></h1>
          </div>

          <div class="d-flex flex-wrap features-list">
            <div v-for="(feature, index) in features" :key="index"
              class="feature-item d-flex align-items-center me-4 mb-3">
              <div class="feature-icon d-flex align-items-center justify-content-center me-2">
                <i :class="`bi bi-${feature.icon}`"></i>
              </div>
              <span class="feature-text">{{ feature.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.hero-section {
  background-color: #1a1b26;
  padding: 1rem 0;
  margin-bottom: 1rem;
}

h1 {
  font-size: 1.75rem;
  font-weight: 700;
}

.feature-item {
  color: #e5e7eb;
}

.feature-icon {
  color: #7e3af2;
  font-size: 1.25rem;
}

.feature-text {
  font-size: 0.9rem;
  font-weight: 500;
}

@media (min-width: 768px) {
  h1 {
    font-size: 2rem;
  }

  .feature-text {
    font-size: 1rem;
  }
}
</style>